export const siteConfig = {
  name: "Online Tryghed",
  phone: "71 74 27 17",
  sms: "93 40 27 17",
  email: "besked@onlinetryghed.dk",
  cvr: "43341758",
  address: "Fruegade 42B, 4200 Slagelse",
  hours: "Alle dage 09:00 – 19:00",
  coverage: "Dækker primært Sjælland",
  colors: {
    primary: "#103B66",
    secondary: "#EAF4FF",
    accent: "#22C55E", // Green for CTAs
  }
};

export const navLinks = [
  { name: "Forside", href: "/" },
  { 
    name: "Services", 
    href: "/#services",
    dropdown: [
      { name: "Tryghedssamtale", href: "/services/tryghedssamtale" },
      { name: "Hjælp mod svindel", href: "/services/hjaelp-mod-svindel" },
      { name: "Teknisk hjælp", href: "/services/teknisk-hjaelp" },
      { name: "Personlig hjælp", href: "/services/personlig-hjaelp" },
    ]
  },
  { name: "Vidensbank", href: "/vidensbank" },
  { name: "Priser", href: "/priser" },
  { name: "Betingelser", href: "/betingelser" },
  { name: "Kontakt", href: "/#kontakt" },
];

export const tips = [
  {
    title: "Del aldrig dine private koder!",
    description: "",
    icon: "ShieldAlert",
  },
  {
    title: "Udlever aldrig dine personlige ejendele!",
    description: "Dine værdier er sikrest bag dine egne døre. Hverken banken, politi eller andre sender personale ud for at sikre dine værdier.",
    icon: "Hand",
  },
  {
    title: "Tag ikke telefonen fra et nummer du ikke kender!",
    description: "Du kan efterfølgende søge på telefonnummeret på www.ukendtnummer.dk",
    icon: "PhoneOff",
  },
  {
    title: "Tryk ikke på links du ikke har tiltro til!",
    description: "Der kommer dagligt mails og sms'er med links fra hvad der ser ud til at være troværdige virksomheder.",
    icon: "ExternalLink",
  },
  {
    title: "Lad være med at åbne døren for nogen du ikke kender!",
    description: "Det er sørgeligt at vi er nået dertil, men hellere være på den sikre side.",
    icon: "DoorClosed",
  },
  {
    title: "Aftal et ord med dine pårørende eller os!",
    description: "Vi har god erfaring med, at man aftaler et ord med sine pårørende. Det ord er med til at sikre, at man ved, at man har fat i en pårørende eller os.",
    icon: "Users",
  },
];

export const services = [
  {
    category: "Tryghedssamtale",
    href: "/services/tryghedssamtale",
    items: [
      { name: "Første telefonkonsultation (ca. 10-15 min)", price: "99,-" },
      { name: "Telefonisk rådgivning", price: "249,-" },
    ],
    icon: "HeartHandshake",
  },
  {
    category: "Hjælp mod svindel",
    href: "/services/hjaelp-mod-svindel",
    items: [
      { name: "Mistænkelige mails" },
      { name: "Falske bankopkald" },
      { name: "Facebook-svindel" },
      { name: "SMS-svindel" },
    ],
    icon: "ShieldCheck",
  },
  {
    category: "Teknisk hjælp",
    href: "/services/teknisk-hjaelp",
    items: [
      { name: "Computer & Tablet" },
      { name: "Internet & WiFi" },
      { name: "Mobil & TV" },
      { name: "Mail-opsætning" },
    ],
    icon: "Monitor",
  },
  {
    category: "Personlig hjælp",
    href: "/services/personlig-hjaelp",
    items: [
      { name: "Fjernsupport" },
      { name: "Hjemmebesøg" },
      { name: "Udpakning & Installation" },
    ],
    icon: "UserCheck",
  },
];

export const steps = [
  {
    title: "1. Kontakt os",
    description: "Ring, send en SMS eller skriv en mail. Vi svarer hurtigt.",
  },
  {
    title: "2. Vi finder løsningen",
    description: "Vi aftaler om du har brug for telefonhjælp, fjernsupport eller et hjemmebesøg.",
  },
  {
    title: "3. Du bliver tryg igen",
    description: "Vi yder rolig og personlig hjælp i dit helt eget tempo, indtil alt virker.",
  },
];

export const pricing = {
  billingInterval: "Vi fakturerer pr. påbegyndt halve time.",
  vatIncluded: "Alle priser er inkl. moms.",
  drivingTerms: "Vi kører ud fra Slagelse og tager 10,- pr. km til kunden. Hjemturen faktureres kunden ikke for.",
  rates: [
    {
      title: "Telefon & fjernsupport",
      price: "249,-",
      unit: "pr. påbegyndt 1/2 time",
      description: "Hurtig og effektiv hjælp over telefonen eller via sikker fjernstyring af din computer eller tablet.",
      features: [
        "Perfekt til mindre tekniske problemer",
        "Akut hjælp ved mistanke om svindel",
        "Sikker og krypteret fjernforbindelse"
      ]
    },
    {
      title: "Personligt fremmøde",
      price: "349,-",
      unit: "pr. påbegyndt 1/2 time",
      description: "Vi kommer hjem til dig i trygge rammer, hvor vi løser problemerne sammen i dit eget tempo.",
      features: [
        "Personlig hjælp i dit eget hjem",
        "Tålmodig vejledning på almindeligt dansk",
        "Kørsel: 10,- pr. km (kun udrejsen)",
        "Udgift til bro faktureres 1:1"
      ]
    }
  ],
  specialOffer: {
    title: "Første telefonkonsultation",
    price: "99,-",
    duration: "ca. 10-15 minutter",
    description: "Første samtale koster kun 99 kr. (ca. 10-15 minutter). Her gennemgår vi dine spørgsmål i ro og mag og rådgiver om, hvordan du beskytter dig mod svindel og datalæk. Samtidig opretter vi dig i vores system, så vi altid kan se, om du har ringet før, og sikre dig den bedst mulige personlige hjælp."
  }
};

export const testimonials = [
  {
    name: "Erik Jensen",
    location: "Slagelse",
    quote: "Jeg føler mig meget mere tryg nu, når jeg bruger min computer. De forklarede tingene så roligt, at selv jeg kunne følge med.",
    stars: 5
  },
  {
    name: "Karen Marie",
    location: "Korsør",
    quote: "Hurtig hjælp da jeg fik en mærkelig SMS. Det er guld værd at have nogen at ringe til, når man er i tvivl.",
    stars: 5
  },
  {
    name: "Poul-Erik",
    location: "Skælskør",
    quote: "Professionelt og tålmodigt. De hjalp mig med at få styr på MitID og sikkerheden på min iPad. Kan varmt anbefales.",
    stars: 5
  },
  {
    name: "Bente Nielsen",
    location: "Næstved",
    quote: "Fantastisk service! De hjalp mig med at rydde op i min computer, så den nu kører som ny. Meget tillidvækkende.",
    stars: 5
  },
  {
    name: "Hans Jørgen",
    location: "Ringsted",
    quote: "Jeg var tæt på at blive snydt af en falsk mail, men efter en samtale med OnlineTryghed ved jeg præcis, hvad jeg skal kigge efter.",
    stars: 5
  },
  {
    name: "Inger Lise",
    location: "Sorø",
    quote: "Dejligt med personlig hjælp i hjemmet. Det giver en helt anden ro, end når man skal forklare tingene over telefonen.",
    stars: 5
  }
];

export const cases = [
  {
    id: "bank-svindel",
    title: "86-årig tog fusen på falske bankmænd",
    description: "Vi arbejder hver dag med at beskytte borgere mod svindel og kontaktbedrageri. Denne historie viser, hvor vigtigt det er at være forberedt.",
    image: "https://assets.auxodev.dk/assets/2cadb5d8-c2c5-4850-ae22-0167799adce5/image.png",
    cta: "Læs historien"
  }
];
